import { css, CSSObject, SerializedStyles } from '@emotion/react'
import { modernWithFallback } from '@opallabs/lapidary'

export interface OverlayStylesGeneratorArg {
  backgroundColor: string
  left: number
  right: number
}

type OverlayStylesGenerator = (
  arg: OverlayStylesGeneratorArg
) => SerializedStyles

export const overlayStyles: OverlayStylesGenerator = ({
  backgroundColor,
  left,
  right,
}) =>
  css({
    position: 'fixed',
    top: '0',
    bottom: '0',
    left: `${left}px`,
    right: `${right}px`,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    background: backgroundColor,
    zIndex: 9998,
  })

export const headerStyles = css({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
})

export const scrollWindowStyles = css({
  width: '100%',
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
  overflow: 'auto',
})

export const getBodyStyles = (overrides: CSSObject): CSSObject => ({
  display: 'flex',
  ...modernWithFallback(
    [
      {
        blockSize: '100vb',
        inlineSize: '100vi',
      },
      {
        blockSize: '100vh',
        inlineSize: '100vw',
      },
    ],
    'width: 1vi'
  ),
  ...overrides,
})

export const footerStyles = css({
  width: '100%',
  position: 'absolute',
  bottom: '0',
  left: '0',
  right: '0',
})
